import { render, staticRenderFns } from "./DashboardOverallDetails.vue?vue&type=template&id=61615a5a&scoped=true"
import script from "./DashboardOverallDetails.vue?vue&type=script&lang=js"
export * from "./DashboardOverallDetails.vue?vue&type=script&lang=js"
import style0 from "./DashboardOverallDetails.vue?vue&type=style&index=0&id=61615a5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61615a5a",
  null
  
)

export default component.exports